import { ServiceWorkerModule } from '@angular/service-worker';

import { urlUtils } from '@blaze-shared/platform-util';

import { APP_VERSION } from '../app-version';

export function getFilePath(): string {
  // Service-Worker-Allowed only needs to cover the parent path of every project
  // scope (/app/ covers /app/projectA, /app/projectB, ...). Matching the allowance
  // exactly to the scope is fragile because the browser does literal string compare
  // of percent-encoded paths.
  const swAllowedPath = urlUtils.getRootPath();

  const ngswPath = urlUtils.isLocalHostUrl()
    ? `/ngsw-worker.js?allowed=${swAllowedPath}`
    : `/${APP_VERSION}/ngsw-worker.js?allowed=${swAllowedPath}/`;
  return ngswPath;
}

export function getScope(): string | undefined {
  return urlUtils.getPublishedProjectRootPath();
}

export function isEnabled(): boolean {
  const isPWA = !!document.querySelector('link[rel="manifest"]');
  const isEnabled = isPWA && urlUtils.isPublishedMode();
  console.log(`Service Worker is ${isEnabled ? 'enabled' : 'disabled'}`, { isPWA });
  return isEnabled;
}

export const SERVICE_WORKER_MODULE = ServiceWorkerModule.register(getFilePath(), {
  // For localhost service worker is always registered. In other cases, only in published mode.
  enabled: isEnabled(),
  // Register the ServiceWorker immediately to avoid hanging issues if the app never stabilizes
  registrationStrategy: 'registerWhenStable:5000',
  // Published project paths are /app/AppName or /p/AppName (no trailing slash).
  // SW scope is a strict prefix match — a trailing slash on the scope would exclude
  // the index page itself, leaving it uncontrolled and breaking push notifications.
  scope: getScope(),
});
